import cx from "classnames";
import React, { CSSProperties } from "react";
import { CompanyRolePermission } from "shared/api";
import { Checkbox } from "shared/ui";
import styles from "./role-permissions.module.scss";

export interface IRolePermissions {
  value: Set<CompanyRolePermission>;
  onChange: (value: Set<CompanyRolePermission>) => void;

  readOnly?: boolean;

  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const RolePermissions = (props: IRolePermissions) => {
  const checkbox = (permission: CompanyRolePermission) => ({
    checked: props.value.has(permission),
    onChange: (checked: boolean) => {
      const result = new Set(props.value);
      if (checked) {
        result.add(permission);
      } else {
        result.delete(permission);
      }
      return props.onChange(result);
    },
    disabled: props.readOnly,
  });

  return (
    <div className={cx(styles.role_permissions, props.className)} style={props.style} id={props.htmlId}>
      <div className={styles.group}>
        <div className={styles.label}>Заявки</div>

        <Checkbox {...checkbox(CompanyRolePermission.CLAIM_READ_ALL)}>Видеть все</Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.CLAIM_APPROVE)}>Утверждать</Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING)}>
          Допускать до планирования
        </Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.CLAIM_PAY_OFF)}>Выплачивать</Checkbox>
      </div>
      <div className={styles.group}>
        <div className={styles.label}>Финансовые планирования</div>

        <Checkbox {...checkbox(CompanyRolePermission.FINANCIAL_PLAN_READ)}>Видеть</Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.FINANCIAL_PLAN_CONDUCT)}>Проводить</Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.FINANCIAL_PLAN_APPROVE)}>Утверждать</Checkbox>
      </div>
      <div className={styles.group}>
        <div className={styles.label}>Фонды</div>

        <Checkbox {...checkbox(CompanyRolePermission.FUND_WITHDRAW)}>Делать списания</Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.FUND_DEPOSIT)}>Делать пополнения</Checkbox>
        <Checkbox {...checkbox(CompanyRolePermission.FUND_SECURED_READ)}>Доступ к защищенным фондам</Checkbox>
      </div>
    </div>
  );
};

RolePermissions.defaultProps = {};
